import i18n from "i18n";
import useModelProviders from "ai-management/hooks/useModelProviders";
import useModelsQuery from "ai-management/hooks/useModelsQuery";
const disabledProviderHintFor = (providerConfig, configuredDefault, defaultProviderName) => {
  if (!providerConfig || providerConfig.enabled || providerConfig.is_default) {
    return void 0;
  }
  return (configuredDefault == null ? void 0 : configuredDefault.enabled) ? i18n.t("provider_model_options.disabled_uses_default", { ns: "enterprise_ai", provider: defaultProviderName }) : i18n.t("provider_model_options.disabled_no_usable_default", { ns: "enterprise_ai" });
};
const useProviderModelOptions = (providers, providerId) => {
  var _a, _b, _c;
  const { data: providerTypes, isLoading: providersLoading } = useModelProviders();
  const configuredDefault = providers.find(({ is_default }) => is_default);
  const providerConfig = providers.find(({ provider }) => provider === providerId);
  const { data: models, isFetching: modelsLoading } = useModelsQuery(providerId != null ? providerId : "", "stored");
  const providerNames = Object.fromEntries(providerTypes.map(({ id, display }) => [id, display]));
  const providerOptions = providers.map(({ provider, enabled }) => {
    var _a2;
    return {
      value: provider,
      label: (_a2 = providerNames[provider]) != null ? _a2 : provider,
      disabled: !enabled
    };
  });
  const defaultModelId = providerConfig == null ? void 0 : providerConfig.default_model_id;
  const defaultModelName = (_b = (_a = models.find(({ id }) => id === defaultModelId)) == null ? void 0 : _a.name) != null ? _b : defaultModelId;
  const modelOptions = models.map(({ id, name }) => ({ value: id, label: name }));
  const defaultProviderName = configuredDefault && ((_c = providerNames[configuredDefault.provider]) != null ? _c : configuredDefault.provider);
  const providerPlaceholder = configuredDefault ? i18n.t("provider_model_options.default_placeholder", { ns: "enterprise_ai", name: defaultProviderName }) : i18n.t("provider_model_options.no_provider_configured", { ns: "enterprise_ai" });
  let modelPlaceholder = i18n.t("config_form.model_placeholder.select_provider_first", { ns: "enterprise_ai" });
  if (providerId) {
    modelPlaceholder = defaultModelName ? i18n.t("provider_model_options.default_placeholder", { ns: "enterprise_ai", name: defaultModelName }) : i18n.t("provider_model_options.no_models_available", { ns: "enterprise_ai" });
  }
  return {
    providerOptions,
    modelOptions,
    providerPlaceholder,
    modelPlaceholder,
    providersLoading,
    modelsLoading,
    disabledProviderHint: disabledProviderHintFor(providerConfig, configuredDefault, defaultProviderName)
  };
};
export default useProviderModelOptions;
